import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useLanguage } from '../../i18n/LanguageContext';

interface DeloadBadgeProps {
  consecutiveFailures: number;
}

export const DeloadBadge: React.FC<DeloadBadgeProps> = ({ consecutiveFailures }) => {
  const { t } = useLanguage();

  if (consecutiveFailures === 0) return null;

  if (consecutiveFailures >= 3) {
    return (
      <Chip
        size="small"
        icon={<WarningIcon />}
        label={t('programs.deload')}
        color="error"
        sx={{ ml: 1 }}
      />
    );
  }

  // 1 or 2 failures — warn that deload is approaching
  return (
    <Tooltip title={t('programs.deloadWarning')}>
      <Chip
        size="small"
        icon={<WarningIcon />}
        label={`${consecutiveFailures}/3`}
        color="warning"
        sx={{ ml: 1 }}
      />
    </Tooltip>
  );
};
